import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Row } from "antd";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Layout from "../../../components/Layout";
import { customBaseUrl, httpGet } from "../../../store/http";
import { useMatStyles } from "./style";
import { hideLoader, showLoader } from "../../../utils/loader";
import noDataLogo from "../../../assets/images/no-data.png";

const TransactionsDone = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
  });
  const styles = useMatStyles();
  const [allTransfers, setAllTransfers] = useState(0);
  const [allTransactions, setAllTransactions] = useState([]);

  const getTransactions = useCallback(async () => {
    setAllTransactions([]);
    showLoader();
    let request = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/get-user-transaction-count`
    );
    if (Array.isArray(request)) {
      setAllTransactions(request);
      setAllTransfers(request.length);
    }
    hideLoader();
  }, []);

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getTransactions();
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getTransactions();
  };

  const columns = useMemo(() => [
    {
      field: 'userId',
      headerName: 'Full Name',
      width: 250,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.user?.cust_name || 'N/A'
    },
    {
      field: 'email',
      headerName: "Email",
      width: 250,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.user?.emailAddress || 'N/A'
    },
    {
      field: 'mobileNo',
      headerName: "Phone",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.user?.mobileNo || 'N/A'
    },
    {
      field: 'totalCount',
      headerName: "No. of Transactions",
      width: 150,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'cust_opn_date',
      headerName: "Date created",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.user?.cust_opn_date || 'N/A'
    }
  ], [styles.tableHeader]);

  return (
    <Layout>
      <div
        style={{ cursor: "pointer", marginBottom: "20px" }}
        onClick={() => navigate("/users/referral")}
      >
        <span className="me-1">
          <ArrowLeftOutlined />
        </span>
        back
      </div>

      {allTransactions?.length > 0 ? (
        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            getRowId={row => row.userId || row.id}
            className={styles.table}
            density="comfortable"
            rows={allTransactions}
            columns={columns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={handleChangeRowsPerPage}
            onPageChange={handleChangePage}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={allTransfers}
          />
        </div>
      ) : (
        <>
          <Row
            type="flex"
            justify="center"
            align="middle"
            className="mt-5"
            style={{ minHeight: "40vh" }}
          >
            <img src={noDataLogo} alt="nodata" style={{ height: "300px" }} />
          </Row>
          <h4 className="mt-3 text-center">No Request yet</h4>
          <p className="mt-3 text-center" style={{ color: '#8C8C8C' }}>
            Request will appear here when you have transactions
          </p>
        </>
      )}
    </Layout>
  );
};

export default TransactionsDone;
